import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

// ---------------------------------------------------------------------------
// Helpers de sessão (mesmo padrão dos demais serviços do projeto)
// ---------------------------------------------------------------------------
const getSession = () => {
  try {
    const raw = sessionStorage.getItem('ddesp');
    if (!raw) return { emp: 0, uid: 0, token: null };
    const arr = JSON.parse(base64_decode(raw));
    return {
      emp: arr?.[0] || 0,
      uid: arr?.[3] || 0,
      token: arr?.[14] || null,
    };
  } catch {
    return { emp: 0, uid: 0, token: null };
  }
};

const API_URL = `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`;
const DESTINO = 'comentariosDoc';

/**
 * Decodifica a resposta padrão do backend (base64 → JSON).
 */
const decode = (data) => JSON.parse(base64_decode(data));

const ajaxComentariosDoc = (type, ll, payload) =>
  new Promise((resolve, reject) => {
    try {
      const { emp, uid, token } = getSession();
      const dd = [
        base64_encode(String(emp)),
        base64_encode(String(uid)),
        base64_encode(JSON.stringify(payload)),
      ];

      $.ajax({
        url: API_URL,
        type,
        dataType: 'json',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: {
          pp: base64_encode(DESTINO),
          ll: base64_encode(ll),
          dd: base64_encode(JSON.stringify(dd)),
          tk: token,
        },
        success: (data) => {
          try {
            resolve([200, decode(data)]);
          } catch {
            reject([400, { message: 'Resposta inválida' }]);
          }
        },
        error: (xhr) => reject([xhr.status || 400, { message: xhr.responseText || 'Erro na requisição' }]),
      });
    } catch (err) {
      reject([500, { message: 'Server Error' }]);
    }
  });

const RestComentariosDocGet = (config) => {
  const caminho = config.dest.trim();

  switch (caminho) {
    case 'listar':
      return ajaxComentariosDoc('GET', 'listar', config.dataPost);
    default:
      return new Promise(function (resolve, _reject) {
        resolve([400, { message: 'Destino inválido' }]);
      });
  }
};

const RestComentariosDocPost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();

  switch (caminho) {
    case 'salvar':
      return ajaxComentariosDoc('POST', 'salvar', Arr_.dataPost);
    case 'excluir':
      return ajaxComentariosDoc('POST', 'excluir', Arr_.dataPost);
    default:
      return new Promise(function (resolve, _reject) {
        resolve([400, { message: 'Destino inválido' }]);
      });
  }
};

export { RestComentariosDocGet, RestComentariosDocPost };
